import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const fetchCohortFastqPairs = async ({
  page = 0,
  limit = 10,
  sort_order = 'desc',
  sample_name = '',
  file_name = '',
  bed_panel = '',
} = {}) => {
  const params = new URLSearchParams()
  params.set('page', String(page))
  params.set('limit', String(limit))
  params.set('sort_order', sort_order)
  if (sample_name) params.set('sample_name', sample_name)
  if (file_name) params.set('file_name', file_name)
  if (bed_panel) params.set('bed_panel', bed_panel)

  const url = `${API_BASE_URL}/cohort/list/?${params.toString()}`
  const { data } = await axios.get(url)
  return data
}

export const startGatkCohortAnalysis = async ({ name, fastq_file_pair_id_list, ref_bed_file_id }) => {
  // GATK CNV cohort payload
  const payload = {
    cohort_name: name,
    fastq_file_pair_id_list,
    ref_bed_file_id,
  }
  const url = `${API_BASE_URL}/cnv_cohorts`
  const { data } = await axios.post(url, payload)
  return data
}

export const startExomeDepthCohortAnalysis = async ({ name, fastq_file_pair_id_list, ref_bed_file_id }) => {
  // ExomeDepth CNV cohort payload
  const payload = {
    cohort_name: name,
    fastq_file_pair_id_list,
    ref_bed_file_id,
  }
  const url = `${API_BASE_URL}/exomedepth_cohorts`
  const { data } = await axios.post(url, payload)
  return data
}

export const fetchGatkCohorts = async () => {
  const url = `${API_BASE_URL}/cnv_cohorts`
  const { data } = await axios.get(url)
  return data
}

export const fetchGatkCohortDetail = async (cohortId) => {
  const url = `${API_BASE_URL}/cnv_cohorts/${cohortId}`
  const { data } = await axios.get(url)
  return data
}

export const fetchExomeDepthCohorts = async () => {
  const url = `${API_BASE_URL}/exomedepth_cohorts`
  const { data } = await axios.get(url)
  return data
}

export const fetchExomeDepthCohortDetail = async (cohortId) => {
  const url = `${API_BASE_URL}/exomedepth_cohorts/${cohortId}`
  const { data } = await axios.get(url)
  return data
}
